import api from "../..";
import type { PatchEventParams } from "./types";

export const patchEvent = async (params: PatchEventParams): Promise<boolean> => {

  const { slugOrId, body } = params;

  return await api.patch(`/event/${slugOrId}/`, body)
  .then(() => true)
  .catch(() => false);
};
